import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { InputDesktop } from '../../../input/esm/desktop';
import { InputAutocompleteDesktop } from '../../../input-autocomplete/esm/desktop';
import { SelectDesktop } from '../../../select/esm/desktop';
import { BaseInternationalPhoneInput } from '../components/base-international-phone-input/Component.js';
import 'react-merge-refs';
import '@maskito/core';
import '@maskito/react';
import '../../../select/esm/shared';
import '../../../shared/esm';
import '../utils/index.js';
import '../consts.js';
import '../data/country-data.js';
import '../components/country-select/Component.js';
import '@alfalab/icons-glyph/WorldMagnifierMIcon';
import '../components/flag-icon/component.js';
import 'classnames';
import '../components/flag-icon/flagSprite.js';
import '../components/select-field/component.js';
import '@alfalab/hooks';

var InternationalPhoneInputDesktop = forwardRef(function (props, ref) { return (React.createElement(BaseInternationalPhoneInput, __assign({ selected: props.value }, props, { view: 'desktop', ref: ref, SelectComponent: SelectDesktop, Input: InputDesktop, InputAutocomplete: InputAutocompleteDesktop }))); });

export { InternationalPhoneInputDesktop };
